export default "__VITE_ASSET__D7cGc$qC__"